<template>
  <div>
    <div class="text-center confirm-container container-box-step4">
      <div class="icon-section">
        <em class="fal fa-check-circle" />
      </div>
      <div class="message-section">
        <strong>¡Gracias por completar el cuestionario!</strong>
        <p>Su número de confirmación es {{ confirmationNumber }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { modulesName } from '@/modules';
import { createNamespacedHelpers } from 'vuex';
const moduleName = modulesName.welcomePortalModuleName;
const { mapGetters } = createNamespacedHelpers(moduleName);

export default {
  name: 'Tab4',
  computed: {
    ...mapGetters({
      confirmationNumber: 'getConfirmationNumber',
    }),
  },
};
</script>

<style scoped lang="scss">
.confirm-container {
  padding: 50px;
  .icon-section {
    margin-bottom: 20px;
    em {
      font-size: 10em;
      color: #2db782;
    }
  }
  .message-section {
    strong {
      text-align: center;
      font: Bold 32px/39px Lato;
      letter-spacing: 0px;
      color: #2db782;
    }
    p {
      text-align: center;
      font: Bold 24px/29px Lato;
      letter-spacing: 0px;
      color: #11291b;
      margin-top: 10px;
    }
  }
}
</style>
